import { useLocation, useNavigate } from 'react-router';

import { Icon, VerticalTabs } from '@/shared/ui';

import { ROUTES } from '@/router/config';

import { UserRequestFiltersOptionsV2 } from '@/api/types';

interface Props {
  scopes?: UserRequestFiltersOptionsV2['scopes'];
}
type ScopeOption = UserRequestFiltersOptionsV2['scopes'][number];

export const UserRequestsNavigation: React.FC<Props> = ({ scopes }) => {
  const labelsByScopeId = (scopes || []).reduce<Record<string, string>>(
    (acc: Record<string, string>, scope: ScopeOption) => {
      acc[scope.id] = scope.label;
      return acc;
    },
    {},
  );

  const tabs = [
    {
      label: labelsByScopeId.active || 'Активні запити',
      slug: ROUTES.USER.REQUESTS.ACTIVE_REQUESTS,
    },
    {
      label: labelsByScopeId.archive || 'Архів запитів',
      slug: ROUTES.USER.REQUESTS.ARCHIVED_REQUESTS,
    },
    {
      label: labelsByScopeId.draft || 'Чернетки',
      slug: ROUTES.USER.REQUESTS.DRAFT_REQUESTS,
    },
  ];

  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <VerticalTabs
      defaultActiveKey={pathname}
      items={tabs.map((tab) => ({
        key: tab.slug,
        label: tab.label,
        icon: <Icon name="chevron_right" />,
      }))}
      onChange={navigate}
    />
  );
};
